import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import Select from 'react-select'
import Select, { components } from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Table } from 'antd';
import { Icon } from '@ohif/ui';
import { colourOptions, getValueListBySearch } from './makeData';

// 判断两个对象是否相同
// const isObjectValueEqual = (obj1, obj2) => {
//     var aProps = Object.getOwnPropertyNames(obj1);
//     var bProps = Object.getOwnPropertyNames(obj2);
//     if (aProps.length != bProps.length) {
//         return false;
//     }
//     for (var i = 0; i < aProps.length; i++) {
//         var propName = aProps[i]

//         var propA = obj1[propName]
//         var propB = obj2[propName]
//         if ((typeof (propA) === 'object')) {
//             if (this.isObjectValueEqual(propA, propB)) {
//                 // return true     这里不能return ,后面的对象还没判断
//             } else {
//                 return false
//             }
//         } else if (propA !== propB) {
//             return false
//         } else { }
//     }
//     return true
// }

const setHistory = value => {
  value = value.filter(i => i.pid !== 0);
  let arr = [];
  if (localStorage.getItem('searchHistory')) {
    arr = JSON.parse(localStorage.getItem('searchHistory'));
  }
  if (arr.length > 0) {
    if (value.length === 1) {
      var isHave = arr.some(item => item.value === value[0].value);
      if (isHave) {
        // 如果存在
        // do something
      } else {
        arr.unshift(value[0]);
        localStorage.setItem('searchHistory', JSON.stringify(arr.slice(0, 10)));
      }
    }
  } else {
    arr.unshift(value);
    localStorage.setItem('searchHistory', JSON.stringify(value));
  }
};

function MainList({
  getRowValue,
  getFiltersChange,
  columns,
  data,
  appConfig,
  filter,
  pagination,
  onChange,
}) {
  //{value: 'userName', label: '姓名', rid: 1, pid: 0}
  let arr = [];
  let pid = 1;

  if (filter.length > 0) {
    if (Array.isArray(filter)) {
      filter.map((item, index) => {
        if (item.pid == pid) {
          arr.splice(index + pid - 1, 0, colourOptions[pid - 1]);
          pid += 1;
        }
        arr.push(item);
      });
    } else {
      arr = [{ label: filter, value: filter }];
    }
  }

  const [selectValue, setSelectValue] = React.useState(arr);
  // const [selectLength, setSelectLength] = React.useState(0); //当前select的长度
  const [originLength, setOriginLength] = React.useState(0); //上个select的长度 用于判断是增加还是删除
  const [currentSelectId, setCurrentSelectId] = useState(0); //当前select的pid

  const [loadOption2s, setloadOption2s] = React.useState(colourOptions);
  const [currentRowId, setCurrentRowId] = useState('');
  const [menuIsOpen, setMenuIsOpen] = useState();
  const [searchTip, setSearchTip] = useState(0);

  // useEffect(() => {
  //   if (history.action == 'POP') {
  //     console.log('pop');
  //   }
  //   // queryHandler();
  //   return componentWillUnmount;
  // }, [history]);

  // useEffect(() => {
  //   let search = history.location.search + `&name='22'&dic='33'`;
  //   history.push({ search });
  // }, [selectValue, history]);

  // function componentWillUnmount() {
  //   // const nextRoutePathName = history.location.pathname;
  //   // if (nextRoutePathName) {
  //   //   console.log(222);
  //   // }
  // }

  const handleChange = async e => {
    setSelectValue(e);
    if (e) {
      let index = e.length - 1;
      let keyword = [];
      if (e.length > originLength) {
        //selectValue增加
        setOriginLength(e.length);
        if (e && e[index].pid === 0) {
          if (e[index].label) {
            let options = await getValueListBySearch(e[index].value, appConfig);
            let pid = e[index].rid;
            let arr = options.data.map((item, index) => {
              let opt = {};
              opt.value = item;
              opt.label = item;
              opt.pid = pid;
              opt.rid = pid + index;
              opt.isSelect = false;
              return opt;
            });
            setCurrentSelectId(pid);
            // setSelectLength(arr.length);
            setloadOption2s(arr);
          }
          setSearchTip(1);
        } else {
          e.map(item => {
            if (item.pid !== 0) {
              keyword.push(item);
            }
          });
          getFiltersChange(keyword);
          setHistory(e);
        }
      } else {
        //selectValue减少或者无变化
        setOriginLength(e.length);
        if (e && e[index].pid === 0) {
          if (e[index].label) {
            let options = await getValueListBySearch(e[index].value, appConfig);
            let pid = e[index].rid;
            let arr = options.data.map((item, index) => {
              let opt = {};
              opt.value = item;
              opt.label = item;
              opt.pid = pid;
              opt.rid = pid + index;
              opt.isSelect = false;
              return opt;
            });
            setCurrentSelectId(pid);
            setloadOption2s(arr);
          }
          setSearchTip(1);
        } else {
          if (e[index].pid != currentSelectId) {
            setSearchTip(1);
          } else {
            console.log(selectValue);
          }
        }

        e.map(item => {
          if (item.pid !== 0) {
            keyword.push(item);
          }
        });
        if (keyword.length > 0) {
          getFiltersChange(keyword);
          setHistory(e);
        } else {
          getFiltersChange(false);
        }
      }
    } else {
      setCurrentSelectId(0);
      setSearchTip(0);
      setloadOption2s(colourOptions);
      getFiltersChange(false);
      // localStorage.setItem('searchHistory', '');
    }
  };

  const historyValue = async data => {
    setSelectValue(data);
    let keyword = data.value;
    getFiltersChange(keyword);
  };

  const returnSup = () => {
    if (selectValue && selectValue.length > 0) {
      let index = selectValue.length - 1;
      if (selectValue[index].pid == 0) {
        selectValue.splice(index, 1);
        setSelectValue(selectValue);
      }
    }

    setSearchTip(0);
    setloadOption2s(colourOptions);
  };

  const customStyles = {
    menu: base => ({
      ...base,
      backgroundColor: '#556472',
      zIndex: 4,
    }),
    menuList: base => ({
      ...base,
      paddingTop: '0px',
    }),
    option: (provided, state) => ({
      ...provided,
      color: '#FFFFFF',
      backgroundColor: state.isFocused ? '#91B9CD' : '#556472',
      padding: '12px 20px',
      height: '40px',
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      color: '#fff',
      width: '100%',
      height: 40,
      alignItems: 'center',
      display: 'flex',
      backgroundColor: '#2C363F',
      margin: 0,
      padding: 0,
      borderRadius: 6,
    }),
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        color: '#fff',
        backgroundColor: '#556472',
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: '#fff',
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: 'white',
      ':hover': {
        backgroundColor: 'white',
        color: 'white',
      },
    }),
    // multiValueRemove: (base, state) => {
    //     return state.data.isFixed ? { ...base, display: 'none' } : base;
    // },

    // singleValue: (provided, state) => {
    //     const opacity = state.isDisabled ? 0.5 : 1;
    //     const transition = 'opacity 300ms';
    //     color = '#fff';

    //     const height = '40pxs';

    //     return { ...provided, height };
    // }
  };

  const menuHeaderStyle = {
    padding: '8px 20px',
    background: '#2C363F',
    cursor: 'pointer',
    color: '#91B9CD',
    display: 'flex',
    alignItems: 'center',
  };

  const MenuList = props => {
    if (searchTip === 0) {
      return (
        <>
          <components.MenuList {...props}>
            <div> </div>
            {props.children}
          </components.MenuList>
        </>
      );
    }
    if (searchTip === 1) {
      return (
        <components.MenuList {...props}>
          <div style={menuHeaderStyle} onClick={returnSup}>
            <Icon
              style={{
                marginRight: '10px',
              }}
              width="16px"
              height="18px"
              name={'left-arrow'}
            />
            选择其它筛选条件
          </div>
          {props.children}
        </components.MenuList>
      );
    }
  };

  const MultiValueRemove = props => {
    if (props.data.pid === 0) {
      return (
        <components.MultiValueRemove
          {...props}
          style={{
            width: '0px',
          }}
        >
          <div></div>
        </components.MultiValueRemove>
      );
    } else {
      return (
        <components.MultiValueRemove {...props}>
          <Icon width="16px" height="16px" name={'close'} />
        </components.MultiValueRemove>
      );
    }
  };

  const onBlur = e => {
    if (selectValue && selectValue.length > 0) {
      let index = selectValue.length - 1;
      if (selectValue[index].pid == 0) {
        selectValue.splice(index, 1);
        setSelectValue(selectValue);
        setOriginLength(selectValue.length);
      }
    }
    setMenuIsOpen(false);
  };

  const onFocus = () => {
    if (!selectValue) {
      setSearchTip(0);
      setloadOption2s(colourOptions);
    }

    setMenuIsOpen(true);
  };

  return (
    <>
      <div
        className="select"
        style={{
          width: '100%',
          margin: '32px 0',
          display: 'flex',
        }}
      >
        <div>
          <HistorySelect getHistoryValue={historyValue}></HistorySelect>
        </div>
        <div
          style={{
            flex: 1,
            marginLeft: '10px',
          }}
        >
          <CreatableSelect
            styles={customStyles}
            onBlur={onBlur}
            onFocus={onFocus}
            menuIsOpen={menuIsOpen}
            components={{ MenuList, MultiValueRemove }}
            placeholder="搜索结果"
            isMulti
            cacheOptions
            defaultOptions
            value={selectValue}
            options={loadOption2s}
            onChange={handleChange}
          />
        </div>
      </div>

      <div>
        <Table
          className="study-table"
          onRow={record => {
            return {
              onClick: event => {
                setCurrentRowId(record.id);
              }, // 点击行
              onDoubleClick: event => {
                getRowValue(record.studyId, record.id);
              },
            };
          }}
          rowKey="id"
          rowClassName={(record, index) => {
            if (record.id == currentRowId) {
              return 'selected';
            } else {
              return '';
            }
          }}
          columns={columns}
          dataSource={data}
          // loading={loading}
          pagination={pagination}
          scroll={{ y: window.innerHeight - 380 }}
          onChange={onChange}
        />
      </div>
    </>
  );
}

function HistorySelect(props) {
  let arr = [];
  if (localStorage.getItem('searchHistory')) {
    arr = JSON.parse(localStorage.getItem('searchHistory'));
  }
  const historyOptions = arr;
  const historyValue = '';
  const customHistoryStyles = {
    indicatorSeparator: () => {
      null;
    }, // removes the "stick"
    menu: base => ({
      ...base,
      backgroundColor: '#556472',
      width: 240,
      zIndex: 2,
    }),
    option: (provided, state) => ({
      ...provided,
      color: '#ffffff',
      backgroundColor: state.isFocused ? '#91B9CD' : '#556472',
      padding: '12px 20px',
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      color: '#fff',
      width: 100,
      alignItems: 'center',
      display: 'flex',
      background: '#2C363F',
      margin: 0,
      padding: 0,
      borderRadius: 6,
      height: 40,
    }),
    singleValue: (provided, state) => {
      return { ...provided };
    },
  };

  const clearnHistory = () => {
    localStorage.setItem('searchHistory', '');
  };

  const MenuList = props => {
    let arr = [];
    if (localStorage.getItem('searchHistory')) {
      arr = JSON.parse(localStorage.getItem('searchHistory'));
    }
    if (arr.length > 0) {
      return (
        <components.MenuList {...props}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '8px 20px',
              background: '#2C363F',
              fontSize: '15px',
              fontWeight: '400',
              justifyContent: 'space-between',
            }}
          >
            <div>最近搜索历史</div>
            <div
              onClick={clearnHistory}
              style={{
                cursor: 'pointer',
              }}
            >
              清空
            </div>
          </div>
          {props.children}
        </components.MenuList>
      );
    } else {
      return (
        <>
          <components.MenuList {...props}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '8px 20px',
                fontSize: '15px',
                fontWeight: '400',
              }}
            >
              无历史记录{' '}
            </div>
          </components.MenuList>
        </>
      );
    }
  };

  const MultiValueRemove = props => {
    if (props.data.pid === 0) {
      return (
        <components.MultiValueRemove
          {...props}
          style={{
            width: '0px',
          }}
        >
          <div></div>
        </components.MultiValueRemove>
      );
    } else {
      return (
        <components.MultiValueRemove {...props}>
          <Icon width="16px" height="16px" name={'close'} />
        </components.MultiValueRemove>
      );
    }
  };
  return (
    <>
      <Select
        {...props}
        styles={customHistoryStyles}
        value={historyValue}
        // menuIsOpen={true}
        onChange={props.getHistoryValue}
        components={{
          Control: ({ children, ...rest }) => (
            <components.Control {...rest}>
              <Icon
                className={'rotate-icon'}
                style={{
                  width: '240px',
                  marginLeft: '10px',
                }}
                name={'history'}
                width="20px"
                height="20px"
              />
              {children}
            </components.Control>
          ),
          MenuList,
          MultiValueRemove,
        }}
        options={historyOptions}
        placeholder=""
      />
    </>
  );
}

MainList.propTypes = {
  getRowValue: PropTypes.func,
  getFiltersChange: PropTypes.func,
  columns: PropTypes.array,
  data: PropTypes.array,
  appConfig: PropTypes.any,
  filter: PropTypes.array || PropTypes.bool,
  pagination: PropTypes.object,
  onChange: PropTypes.func,
};
export default MainList;
